import { render } from "./RouteForAti.vue?vue&type=template&id=156f27da&scoped=true"
import script from "./RouteForAti.vue?vue&type=script&lang=js"
export * from "./RouteForAti.vue?vue&type=script&lang=js"

import "./RouteForAti.vue?vue&type=style&index=0&id=156f27da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156f27da"]])

export default __exports__